<template>
  <v-container fluid>
    <v-row class="common-card-row">
      <v-col class="common-card-col">
        <v-row class="mt-0 pb-0">
          <v-col cols="12" sm="3">
            <v-select
              v-if="ev_model_list"
              dense
              color="primaryDark"
              v-model="ev_selected_model"
              :items="ev_model_list"
              :label="select_ev_label"
              item-text="ModelName"
              @change="get_evm_hpm_combined_data"
              return-object
            />
          </v-col>
          <v-col cols="12" sm="3">
            <v-select
              v-if="hp_model_list"
              dense
              color="primaryDark"
              v-model="hp_selected_model"
              :items="hp_model_list"
              :label="select_hp_label"
              item-text="ModelName"
              @change="get_evm_hpm_combined_data"
              return-object
            />
          </v-col>
          <v-col cols="12" sm="6">
            <v-row>
              <v-col cols="12" sm="3">
                <v-progress-linear
                  v-model="current_progress"
                  color="light-blue"
                  height="20"
                  v-if="is_loading"
                  style="margin-top: 9px; margin-left: 10px; margin-right: 10px"
                >
                  <template v-slot:default="{ value }">
                    <strong>{{ Math.ceil(value) }}%</strong>
                  </template>
                </v-progress-linear>
              </v-col>
              <v-col cols="12" sm="9" class="text-right">
                <v-btn
                  class="backgroundLight--text"
                  small
                  :disabled="!isPowerUser || is_loading"
                  color="vtblue"
                  @click="run_analysis_realtimeupdate"
                >
                  {{ $t("common.labels.reRunAnalysis") }}
                  <!-- <v-icon class="pl-2" small>mdi-reload</v-icon> -->
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="common-card-row">
      <v-col cols="12" md="3" class="pa-0 pb-3 pb-md-0 pr-md-3">
        <v-col cols="12" class="common-card-col">
          <div class="text-h6 primaryDark--text pb-13">
            {{ $t("views.EVModelling.charts.maxEVSupported.title") }}
          </div>
          <RadialChartVT
            v-if="chartData && chartData[0]"
            :chartData="chartData[0]"
            @on-click="apply_graph_filter($event, 'evCat')"
          />
        </v-col>
      </v-col>
      <v-col cols="12" md="3" class="pa-0 pb-3 pb-md-0 pr-md-3">
        <v-col cols="12" class="common-card-col"
          ><div class="text-h6 primaryDark--text pb-13">
            {{ $t("views.EVModelling.charts.maxHPSupported.title") }}
          </div>
          <RadialChartVT
            v-if="chartData && chartData[2]"
            :chartData="chartData[2]"
            @on-click="apply_graph_filter($event, 'hpCat')"
        /></v-col>
      </v-col>
      <v-col cols="12" md="6" class="pa-0">
        <v-col cols="12" class="common-card-col"
          ><div class="text-h6 primaryDark--text">
            {{ $t("views.EVModelling.charts.firstYearOverCapacity.title") }}
          </div>
          <ColumnChartVT
            v-if="chartData && chartData[1]"
            :xlabel="first_year_x_label"
            :ylabel="first_year_y_label"
            :isStacked="false"
            :chartData="chartData[1]"
            @on-click-inner-col="apply_graph_filter($event, 'FirstYearOverCapacity')"
          />
        </v-col>
      </v-col>
    </v-row>
    <v-row class="common-card-row pb-3">
      <v-col class="common-card-col">
        <v-col class="pa-0">
          <DataTableVT
            v-if="model_data"
            :headers="page_content.device_evm_table"
            :items_list="filtered_model_data"
            @rowClick="open_details($event)"
            sort_by="MaxLoadDay"
            item_key="DeviceID"
            no_export="true"
            print="false"
          />
        </v-col>
      </v-col>
    </v-row>

    <v-overlay class="layering" :value="dialog">
      <v-card
        :light="!this.$vuetify.theme.dark"
        color="backgroundLight"
        style="width: 80vw; max-height: 80vh; overflow: auto"
      >
        <div class="close-btn">
          <v-btn right @click="closeDialog" outlined color="primaryGrey" class="py-4" x-small>
            <v-icon small color="primaryGrey">mdi-close</v-icon>
          </v-btn>
        </div>
        <div class="pa-0" style="overflow: auto; height: 100%">
          <Asset :deviceId="deviceId" v-if="overlay_type == 'details'" />
        </div>
      </v-card>
    </v-overlay>

    <v-snackbar color="borderDark" v-model="snackbar" timeout="2000">{{ message }}</v-snackbar>
  </v-container>
</template>

<script>
import Asset from "../views/Asset";
import DataTableVT from "../components/DataTableVT";
import RadialChartVT from "../components/RadialChartVT";
import ColumnChartVT from "../components/ColumnChartVT";
import { axios_get, axios_put } from "../services/vt_service";
import { trafo } from "../services/powerdata";
import { content } from "../../config/powerdata_evm.js";
import { redirect_to_asset } from "../helpers/helpers";

const io = require("socket.io-client");
const tenant_key = process.env["VUE_APP_TENANT_KEY"];

var socket;

export default {
  name: "EVModelling",
  components: { Asset, DataTableVT, RadialChartVT, ColumnChartVT },
  data: function () {
    return {
      select_ev_label: this.$t("common.labels.selectEVModel"),
      select_hp_label: this.$t("common.labels.selectHPModel"),
      first_year_x_label: this.$t("views.EVModelling.charts.firstYearOverCapacity.labels.xLabel"),
      first_year_y_label: this.$t("views.EVModelling.charts.firstYearOverCapacity.labels.yLabel"),
      ev_model_list: null,
      hp_model_list: null,
      model_data: null,
      ev_selected_model: null,
      hp_selected_model: null,
      page_content: null,
      message: null,
      snackbar: false,
      current_filter: null,
      is_loading: false,
      current_progress: "0",
      overlay_type: null,
      dialog: false,
      deviceId: null,
    };
  },
  created() {
    this.page_content = content;
  },
  mounted() {
    this.get_evm_list();
    this.get_hpm_list();
  },
  methods: {
    closeDialog() {
      this.dialog = false;
      this.deviceId = null;
    },
    open_details(item) {
      if (item.ctrlKey) return redirect_to_asset(this.$router, "asset", item.DeviceID);
      this.overlay_type = "details";
      this.deviceId = item.DeviceID;
      this.dialog = true;
    },
    getType(column) {
      if (column === 1) return "evYearProp";
      else if (column === 2) return "hpYearProp";
      else return "yearProp";
    },
    getYear(row) {
      const years = ["2023", "2024", "2025", "2026", "2027", "2028", "2029"];
      if (row >= 0 && row < years.length) {
        return years[row];
      } else {
        return "2030+";
      }
    },
    processYearStatsData(yearStats, yearofprob) {
      Object.entries(yearStats).forEach(([year, stats]) => {
        const evOverCapacity = stats.FirstYearOverCapacity_ev || 0;
        const hpOverCapacity = stats.FirstYearOverCapacity_hp || 0;
        const totalOverCapacity = stats.FirstYearOverCapacity || 0;

        yearofprob.push([year, evOverCapacity, hpOverCapacity, totalOverCapacity]);
      });
    },
    processStatsData(data, statsArray, category) {
      Object.keys(data).forEach((key) => {
        statsArray.push([
          key,
          data[key].length,
          {
            msg: `Devices with ${key} ${category}.`,
            title: `${key} ${category}`,
            footer: `${data[key].length} (${Math.round((data[key].length / this.model_data.length) * 1000) / 10}%)`,
          },
        ]);
      });
    },
    getMaxCategory(value) {
      if (value >= 0 && value < 25) {
        return "0-25";
      } else if (value >= 25 && value < 75) {
        return "25-75";
      } else if (value >= 75 && value < 200) {
        return "75-200";
      } else {
        return "200+";
      }
    },
    apply_graph_filter(val, type) {
      this.message = val ? "Filter Applied Successfully!" : "Filter Removed Successfully!";
      this.snackbar = true;
      if (typeof val === "object") {
        return (this.current_filter = val
          ? {
              value: this.getYear(val["row"]),
              type: this.getType(val["column"]),
            }
          : null);
      }
      this.current_filter = val ? { value: val, type: type } : null;
    },
    async get_evm_list() {
      this.dialog = false;
      this.network_error = false;
      const response = await axios_get(trafo.get_evm_list);
      this.ev_model_list = response;
      this.ev_selected_model = response[0];
      if (!this.model_data) this.get_evm_hpm_combined_data();
    },
    async get_hpm_list() {
      this.dialog = false;
      this.network_error = false;
      const response = await axios_get(trafo.get_hpm_list);
      this.hp_model_list = response;
      this.hp_selected_model = response[0];
      if (!this.model_data) this.get_evm_hpm_combined_data();
    },
    get_analysis_id(evModelId, hpModelId) {
      //This method returns the analysis id based on the ev and hp model ids
      const analysisMapping = {
        "1-1": 1,
        "1-2": 2,
        "2-1": 3,
        "1-3": 4,
        "2-2": 5,
        "2-3": 6,
        "3-1": 7,
        "3-2": 8,
        "3-3": 9,
      };

      const modelKey = `${evModelId}-${hpModelId}`;
      if (Object.prototype.hasOwnProperty.call(analysisMapping, modelKey)) {
        return analysisMapping[modelKey];
      }
    },
    async get_evm_hpm_combined_data() {
      this.dialog = false;
      this.network_error = false;
      if (!this.ev_selected_model || !this.hp_selected_model) {
        return;
      }
      let id = this.get_analysis_id(this.ev_selected_model.EVModelID, this.hp_selected_model.HPModelID);
      const response = await axios_get(trafo.get_evm_hpm_combined_data, { id });
      this.model_data = response;
    },
    progress_update(msg) {
      this.current_progress = msg.current_progress;
    },
    create_socket(access_token) {
      const tenant = (this.$auth.user[tenant_key] && this.$auth.user[tenant_key]["tenant"]) || "";
      var self = this;
      socket = io.connect(process.env.VUE_APP_ROOT_API, {
        withCredentials: true,
      });

      socket.on("authenticated", function () {
        //isAuthenticated = true;
        self.run_analysis();
      });

      //---------------------
      socket.on("connect", function () {
        //send the jwt
        socket.emit("authenticate", {
          token: access_token,
          tenant: tenant,
        });
      });

      socket.on("progress-message", this.progress_update);
    },
    run_analysis_realtimeupdate: async function () {
      var access_token = await this.$auth.getTokenSilently();
      this.create_socket(access_token);
      //this.is_loading = !this.is_loading;
    },
    run_analysis: async function () {
      this.is_loading = true;
      this.dialog = false;
      this.network_error = false;
      await axios_put(
        trafo.get_evm_fleetanalysis,
        { id_ev: this.ev_selected_model.EVModelID, id_hp: this.hp_selected_model.HPModelID },
        {
          timeout: 120000,
        }
      );
      this.get_evm_hpm_combined_data();
      this.is_loading = false;
      if (this.socket) {
        socket.disconnect("loading complete");
      }
      this.network_error = true;
      this.error_message = "Server Error!";
      this.snackbar = true;
      this.is_loading = false;
      if (this.socket) {
        socket.disconnect("loading complete");
      }
    },
  },

  computed: {
    isPowerUser: function () {
      const ROLE_KEY = process.env["VUE_APP_ROLE_KEY"];
      let role = this.$auth.user[ROLE_KEY] && this.$auth.user[ROLE_KEY][0];
      return role && role.toLowerCase() == "poweruser" ? true : false;
    },
    cal_stats: function () {
      let maxev = {
        "200+": [],
        "75-200": [],
        "25-75": [],
        "0-25": [],
      };

      let maxhp = {
        "200+": [],
        "75-200": [],
        "25-75": [],
        "0-25": [],
      };

      let yearofprob = {};
      this.model_data &&
        this.model_data.map((elem) => {
          let total_year = elem["FirstYearOverCapacity"] ? elem["FirstYearOverCapacity"].toString() : null;

          let ev_year = elem["FirstYearOverCapacity_ev"] ? elem["FirstYearOverCapacity_ev"].toString() : null;

          let hp_year = elem["FirstYearOverCapacity_hp"] ? elem["FirstYearOverCapacity_hp"].toString() : null;
          if (total_year) {
            if (total_year >= 2030) {
              total_year = "2030+";
            }
            if (!yearofprob[total_year]) {
              yearofprob[total_year] = {
                FirstYearOverCapacity: 0,
                FirstYearOverCapacity_ev: 0,
                FirstYearOverCapacity_hp: 0,
              };
            }
          }
          if (ev_year) {
            if (ev_year >= 2030) {
              ev_year = "2030+";
            }
            if (!yearofprob[ev_year]) {
              yearofprob[ev_year] = {
                FirstYearOverCapacity: 0,
                FirstYearOverCapacity_ev: 0,
                FirstYearOverCapacity_hp: 0,
              };
            }
          }
          if (hp_year) {
            if (hp_year >= 2030) {
              hp_year = "2030+";
            }
            if (!yearofprob[hp_year]) {
              yearofprob[hp_year] = {
                FirstYearOverCapacity: 0,
                FirstYearOverCapacity_ev: 0,
                FirstYearOverCapacity_hp: 0,
              };
            }
          }

          if (elem["FirstYearOverCapacity"]) {
            yearofprob[total_year]["FirstYearOverCapacity"] += 1;
            elem["yearProp"] = total_year >= 2030 ? "2030+" : total_year;
          }
          if (elem["FirstYearOverCapacity_ev"]) {
            yearofprob[ev_year]["FirstYearOverCapacity_ev"] += 1;
            elem["evYearProp"] = ev_year >= 2030 ? "2030+" : ev_year;
          }
          if (elem["FirstYearOverCapacity_hp"]) {
            yearofprob[hp_year]["FirstYearOverCapacity_hp"] += 1;
            elem["hpYearProp"] = hp_year >= 2030 ? "2030+" : hp_year;
          }

          maxev[this.getMaxCategory(elem["MaxEVs"])].push(elem);
          elem["evCat"] = this.getMaxCategory(elem["MaxEVs"]);
          maxhp[this.getMaxCategory(elem["MaxHPs"])].push(elem);
          elem["hpCat"] = this.getMaxCategory(elem["MaxHPs"]);
        });

      return [maxev, yearofprob, maxhp];
    },
    chartData: function () {
      if (!this.model_data) return null;
      let maxev = [
        [
          this.$t("views.EVModelling.charts.maxEVSupported.labels.maxEVs"),
          this.$t("views.EVModelling.charts.maxEVSupported.labels.numberOfDevices"),
          {
            role: "tooltip",
            type: "string",
            p: {
              html: true,
            },
          },
        ],
      ];
      let maxhp = [
        [
          "Max HPs",
          "Number of Devices",
          {
            role: "tooltip",
            type: "string",
            p: {
              html: true,
            },
          },
        ],
      ];
      let yearofprob = [["Year", "EVs Over Capacity Only", "HPs Over Capacity Only", "Combination of EVs and HPs"]];

      this.processStatsData(this.cal_stats[0], maxev, "EVs");
      this.processStatsData(this.cal_stats[2], maxhp, "HPs");
      this.processYearStatsData(this.cal_stats[1], yearofprob);

      return [maxev, yearofprob, maxhp];
    },
    filtered_model_data: function () {
      return this.model_data.filter((elem) => {
        if (!this.current_filter) return true;
        return elem[this.current_filter.type] == this.current_filter.value ? true : false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .right-border {
  border-right: 1px solid var(--v-border-base);
}
::v-deep .top-border {
  border-top: 1px solid var(--v-border-base);
}
</style>
